import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const StyleTab = ({ handleLayoutChange, selectedLayout,updateBusinessHoursTabData,businessHoursTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [backgroundColor, setBackgroundColor] = useState(businessHoursTabData.background_color);
    const [textColor, setTextColor] = useState(businessHoursTabData.text_color);
    const [iconsColor, setIconsColor] = useState(businessHoursTabData.icons_color);
    const [openStatusColor, setOpenStatusColor] = useState(businessHoursTabData.open_status_color);
    const [closedStatusColor, setClosedStatusColor] = useState(businessHoursTabData.closed_status_color);
    const [closedSoonStatusColor, setClosedSoonStatusColor] = useState(businessHoursTabData.closed_soon_status_color);
    const [fontType, setFontType] = useState(businessHoursTabData.font_type);
    const [fontDropdownOpen, setFontDropdownOpen] = useState(false);
    const [textSize, setTextSize] = useState(businessHoursTabData.text_size);
    const [textSizeDropdownOpen, setTextSizeDropdownOpen] = useState(false);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(businessHoursTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(businessHoursTabData.custom_js);
    
    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateBusinessHoursTabData("background_color", color.hex);
    };

    // Handlers Text Color Change
    const handleTextColorChange = (color) => {
        setTextColor(color.hex);
        updateBusinessHoursTabData("text_color", color.hex);
    };

    // Handlers Icons Color Change
    const handleIconsColorChange = (color) => {
        setIconsColor(color.hex);
        updateBusinessHoursTabData("icons_color", color.hex);
    };

    // Handlers Open Status Color Change
    const handleOpenStatusColorChange = (color) => {
        setOpenStatusColor(color.hex);
        updateBusinessHoursTabData("open_status_color", color.hex);
    };

    // Handlers Closed Status Color Change
    const handleClosedStatusColorChange = (color) => {
        setClosedStatusColor(color.hex);
        updateBusinessHoursTabData("closed_status_color", color.hex);
    };

    // Handlers Closed Soon Status Color Change
    const handleClosedSoonStatusColorChange = (color) => {
        setClosedSoonStatusColor(color.hex);
        updateBusinessHoursTabData("closed_soon_status_color", color.hex);
    };

    // Handlers Font Type Change
    const handleFontChange = (font) => {
        setFontType(font);
        updateBusinessHoursTabData("font_type", font);
        setFontDropdownOpen(false);
    };

    // Handlers Text Size Type Change
    const handleTextSizeChange = (font) => {
        setTextSize(font);
        updateBusinessHoursTabData("text_size", font);
        setTextSizeDropdownOpen(false);
    };
    
    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateBusinessHoursTabData("custom_css", code);
    };
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateBusinessHoursTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={backgroundColor} setColor={setBackgroundColor}  onChangeComplete={handleBackgroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Text Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={textColor} setColor={setTextColor}  onChangeComplete={handleTextColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Icons Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={iconsColor} setColor={setIconsColor}  onChangeComplete={handleIconsColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Open Status Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={openStatusColor} setColor={setOpenStatusColor}  onChangeComplete={handleOpenStatusColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Closed Status Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={closedStatusColor} setColor={setClosedStatusColor}  onChangeComplete={handleClosedStatusColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Closed Soon Status Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={closedSoonStatusColor} setColor={setClosedSoonStatusColor}  onChangeComplete={handleClosedSoonStatusColorChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Font</span>
                            <div className="color-pikr-box" onClick={() => setFontDropdownOpen(!fontDropdownOpen)}>
                                <em>{fontType}</em>
                                {fontDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Default"].map((font) => (
                                            <li key={font} onClick={() => handleFontChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Text Size</span>
                            <div className="color-pikr-box" onClick={() => setTextSizeDropdownOpen(!textSizeDropdownOpen)}>
                                <em>{textSize}</em>
                                {textSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12x","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                            <li key={font} onClick={() => handleTextSizeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;